import { FormControl } from '@angular/forms';
export class FormCustomValidator {
    
    static compare: string;
    static compareField: string; 

    public setCompare (f: string)
    {
        FormCustomValidator.compare = f;
    }

    public setCompareField (f: string) 
    {
        FormCustomValidator.compareField = f;
    }

    public validateEmail(c: FormControl) {
        let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

        return EMAIL_REGEXP.test(c.value) ? null : {
            pattern: {
                valid: false
            }
        };

    }

    public dropDownValidate(c: FormControl) {
        if (c.value === '' || c.value.value.length === 0) {
            return {
                required: {
                    valid: false
                }
            };

        }
    }

    public validateReEntry(c: FormControl) {
        if (c) {
            const cmpControl = c.root.get(FormCustomValidator.compareField);
            if (cmpControl) {
                if (cmpControl.value !== c.value) {
                    return {
                        valid: true
                    };
                }
            }
        }
    }

    public validateEntry(c: FormControl) {
        if (c) {
            const cmpControl = c.root.get(FormCustomValidator.compare);
            if (cmpControl) {
                cmpControl.updateValueAndValidity();
            }
        }
    }
}